import {
  KUNCHAN_VALUE_TO_LABEL_MAP,
  BOOK_PRICE_TOKYO_METRO,
  BOOK_PRICE_TOKYO_METRO_HARD_COVER,
  INPUT_NAME_KUN_CHAN,
  INPUT_VALUE_KUN_CHAN_NASHI,
  kunChanArr,
  lmmStoryLinesArr,
  STORY_LINES_TO_NAME_MAP,
} from '@shared/jp/product';
import {
  INPUT_NAME_KIDS_NAME,
  INPUT_VALUE_COVER_TYPE_HARD,
  INPUT_VALUE_COVER_TYPE_SOFT,
  INPUT_NAME_GENDER,
  INPUT_NAME_GLASSES,
  INPUT_VALUE_GENDER_BOY,
  INPUT_VALUE_GENDER_GIRL,
  INPUT_NAME_HAIR_COLOR,
  INPUT_NAME_SKIN_COLOR,
  INPUT_VALUE_HAIR_COLOR_BLACK,
  INPUT_VALUE_HAIR_COLOR_BLONDE,
  INPUT_VALUE_HAIR_COLOR_BROWN,
  INPUT_VALUE_HAIR_COLOR_RED,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H01,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
  INPUT_VALUE_SKIN_COLOR_NUTMEG,
  INPUT_NAME_HAIR_STYLE,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H010,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H011,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H02,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H04,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H05,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H06,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H07,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H08,
  INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H09,
  INPUT_NAME_STORY_LINES,
} from '@shared/common/product';
import type { TGender, THairColor } from '@shared/common/product';
import type { ICanvasInputItem } from '@shared/common/data/inputs';
import {
  bookInputShowWhen,
  getCheckboxInputData,
  getRadioInputData,
  getRadioInputOptionData,
  getSelectInputData,
  getSelectInputOptionData,
  getTextInputData,
  bookInputsToNameValueMap,
  getCanvasInputData,
  INPUT_NAME_RESERVED_CANVAS1,
  getRadioIconInputData,
  getRadioIconInputOptionData,
  getRadioColorInputData,
  getRadioColorInputOptionData,
  getMultiselectInputData,
  getMultiselectInputOptionData,
} from '@shared/common/data/inputs';
import { getPriceData } from '@shared/jp/data/products';
import type { IBookPreview } from '@shared/jp/data/products';
import type { IReview } from '@shared/common/data/products';
import {
  EBannerTextColor,
  EDescriptionTextItemType,
  PURPOSE_ADVENTURE,
  PURPOSE_BIRTH_GIFT,
} from '@shared/common/data/products';
import {
  GET_BOOK_NAME_ERROR,
  getNameValidatorList,
} from '@shared/jp/data/inputs';
import type { THairStyleBoyLMM, THairStyleGirlLMM } from '@shared/jp/product';
import LetsMakeMetroShared from '@shared/jp/vendors/tokyoMetro/data/products/books/LetsMakeMetroShared';
import { getCoverHard, getCoverSoft } from './_utils';

export const LetsMakeMetroInputsKidsName = getTextInputData({
  label: '子どもの下の名前',
  placeholder: 'ひらがな６文字まで',
  name: INPUT_NAME_KIDS_NAME,
  validator: getNameValidatorList(6, 2),
  error: GET_BOOK_NAME_ERROR(6),
} as const);

export const LetsMakeMetroInputsKunChan = getSelectInputData({
  label: 'くん・ちゃん付け',
  placeholder: '選んでください',
  options: kunChanArr.map((value) =>
    getSelectInputOptionData({
      label: KUNCHAN_VALUE_TO_LABEL_MAP[value],
      value,
    }),
  ),
  value: INPUT_VALUE_KUN_CHAN_NASHI,
  name: INPUT_NAME_KUN_CHAN,
} as const);

export const LetsMakeMetroInputsGender = getRadioInputData({
  label: '性別',
  options: [
    getRadioInputOptionData({
      label: '男の子',
      value: INPUT_VALUE_GENDER_BOY,
    }),
    getRadioInputOptionData({
      label: '女の子',
      value: INPUT_VALUE_GENDER_GIRL,
    }),
  ],
  name: INPUT_NAME_GENDER,
});

export const LetsMakeMetroInputsGlasses = getCheckboxInputData({
  label: 'メガネをかける',
  name: INPUT_NAME_GLASSES,
  value: false,
} as const);

export const LetsMakeMetroInputsSkinColor = getRadioColorInputData({
  label: 'Skin color',
  options: [
    getRadioColorInputOptionData({
      color: '#FAD5A2',
      value: INPUT_VALUE_SKIN_COLOR_NUTMEG,
    }),
  ],
  value: INPUT_VALUE_SKIN_COLOR_NUTMEG,
  name: INPUT_NAME_SKIN_COLOR as typeof INPUT_NAME_SKIN_COLOR,
});

export const LetsMakeMetroInputsHairColor = getRadioColorInputData({
  label: 'かみ色',
  options: [
    getRadioColorInputOptionData({
      color: '#F8D992',
      value: INPUT_VALUE_HAIR_COLOR_BLONDE,
    }),
    getRadioColorInputOptionData({
      color: '#CF744B',
      value: INPUT_VALUE_HAIR_COLOR_RED,
    }),
    getRadioColorInputOptionData({
      color: '#9F6D48',
      value: INPUT_VALUE_HAIR_COLOR_BROWN,
    }),
    getRadioColorInputOptionData({
      color: '#4D423B',
      value: INPUT_VALUE_HAIR_COLOR_BLACK,
    }),
  ],
  value: INPUT_VALUE_HAIR_COLOR_BLACK,
  name: INPUT_NAME_HAIR_COLOR as typeof INPUT_NAME_HAIR_COLOR,
});

export const LetsMakeMetroInputsHairStyleBoy = getRadioIconInputData({
  label: 'かみ型',
  options: [
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/buzz.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H01,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/very_short.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H02,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/short_boy.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/mushroom.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H04,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/long.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H05,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/curly.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H06,
    }),
  ],
  value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H01,
  name: INPUT_NAME_HAIR_STYLE as typeof INPUT_NAME_HAIR_STYLE,
});

export const LetsMakeMetroInputsHairStyleGirl = getRadioIconInputData({
  label: 'かみ型',
  options: [
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/short_girl.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/short_bob.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H07,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/medium_bob.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H08,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/long_with_bang.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H09,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/pig_tail.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H010,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/curly_girl.png',
      value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H011,
    }),
  ],
  value: INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
  name: INPUT_NAME_HAIR_STYLE as typeof INPUT_NAME_HAIR_STYLE,
});

const LetsMakeMetroInputsCanvasBoyInputs = [
  LetsMakeMetroInputsHairColor,
  LetsMakeMetroInputsHairStyleBoy,
  LetsMakeMetroInputsGlasses,
];

const LetsMakeMetroInputsCanvasGirlInputs = [
  LetsMakeMetroInputsHairColor,
  LetsMakeMetroInputsHairStyleGirl,
  LetsMakeMetroInputsGlasses,
];

const LetsMakeMetroItemsSkinBoy: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/lmm-canvas/M/TM-BK3-M02.png',
  },
];

const LetsMakeMetroItemsSkinGirl: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/lmm-canvas/M/TM-BK3-M04.png',
  },
];

const LetsMakeMetroItemsHairBoy: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H01.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H01,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H02.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H03.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H04.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H05.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H05,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H06.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H07.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H01,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H08.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H09.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H10.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H11.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H05,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H12.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H13.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H01,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H14.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H15.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H16.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H17.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H05,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H18.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H19.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H01,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H20.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H21.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H22.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H23.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H05,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H24.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleBoy,
        condition: (v: THairStyleBoyLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H06,
      },
    ],
  },
];

const LetsMakeMetroItemsHairGirl: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H25.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H26.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H07,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H27.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H08,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H28.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H09,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H29.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H010,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H30.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H011,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H31.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H32.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H07,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H33.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H08,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H34.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H09,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H35.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H010,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H36.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H011,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H37.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H38.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H07,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H39.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H08,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H40.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H09,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H41.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H010,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H42.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H011,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H43.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H44.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H07,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H45.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H08,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H46.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H09,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H47.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H010,
      },
    ],
  },
  {
    imgSrc: 'assets/images/lmm-canvas/H/TM-BK3-H48.png',
    showWhen: [
      {
        inputToCheck: LetsMakeMetroInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: LetsMakeMetroInputsHairStyleGirl,
        condition: (v: THairStyleGirlLMM) =>
          v === INPUT_VALUE_HAIR_STYLE_LETS_MAKE_METRO_H011,
      },
    ],
  },
];

const LetsMakeMetroBabyInputsCanvasCommon = {
  width: 312,
  height: 459,
  crop: {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10,
  },
  cropLtMd: {
    top: 15,
    left: 30,
    bottom: 220,
  },
  name: INPUT_NAME_RESERVED_CANVAS1,
} as const;

export const LetsMakeMetroInputsCanvasBoy = getCanvasInputData({
  ...LetsMakeMetroBabyInputsCanvasCommon,
  name: INPUT_NAME_RESERVED_CANVAS1 as typeof INPUT_NAME_RESERVED_CANVAS1,
  label: '子どもにそっくりの主人公を作りましょう！',
  inputs: LetsMakeMetroInputsCanvasBoyInputs,
  items: [
    ...LetsMakeMetroItemsSkinBoy,
    ...LetsMakeMetroItemsHairBoy,
    {
      imgSrc: 'assets/images/lmm-canvas/G/TM-BK3-G01.png',
      showWhen: [
        {
          inputToCheck: LetsMakeMetroInputsGlasses,
          condition: (v: boolean) => v,
        },
      ],
    },
  ],
  value: bookInputsToNameValueMap(LetsMakeMetroInputsCanvasBoyInputs),
});

export const LetsMakeMetroInputsCanvasGirl = getCanvasInputData({
  ...LetsMakeMetroBabyInputsCanvasCommon,
  name: INPUT_NAME_RESERVED_CANVAS1 as typeof INPUT_NAME_RESERVED_CANVAS1,
  label: '子どもにそっくりの主人公を作りましょう！',
  inputs: LetsMakeMetroInputsCanvasGirlInputs,
  items: [
    ...LetsMakeMetroItemsSkinGirl,
    ...LetsMakeMetroItemsHairGirl,
    {
      imgSrc: 'assets/images/lmm-canvas/G/TM-BK3-G01.png',
      showWhen: [
        {
          inputToCheck: LetsMakeMetroInputsGlasses,
          condition: (v: boolean) => v,
        },
      ],
    },
  ],
  value: bookInputsToNameValueMap(LetsMakeMetroInputsCanvasGirlInputs),
});

export const LetsMakeMetroInputsStoryLines = getMultiselectInputData({
  options: lmmStoryLinesArr.map((line) =>
    getMultiselectInputOptionData({
      imgSrc: `assets/images/icons/lmm-story-lines/icon_${line}.png`,
      label: STORY_LINES_TO_NAME_MAP[line],
      value: line,
    }),
  ),
  name: INPUT_NAME_STORY_LINES,
  placeholder: '1～6歳',
});
// * mutations
bookInputShowWhen(
  LetsMakeMetroInputsCanvasGirl,
  LetsMakeMetroInputsGender,
  (gender: TGender) => gender === INPUT_VALUE_GENDER_GIRL,
);

bookInputShowWhen(
  LetsMakeMetroInputsCanvasBoy,
  LetsMakeMetroInputsGender,
  (gender: TGender) => gender === INPUT_VALUE_GENDER_BOY,
);

const prices = {
  [INPUT_VALUE_COVER_TYPE_SOFT]: getPriceData(BOOK_PRICE_TOKYO_METRO),
  [INPUT_VALUE_COVER_TYPE_HARD]: getPriceData(
    BOOK_PRICE_TOKYO_METRO_HARD_COVER,
  ),
} as const;

const coverSoft = getCoverSoft({
  price: prices[INPUT_VALUE_COVER_TYPE_SOFT],
  carousel: [
    'assets/images/covers/letsmakemetro/SC01.jpg',
    'assets/images/covers/letsmakemetro/SC02.jpg',
    'assets/images/covers/letsmakemetro/SC03.jpg',
  ],
});
const coverHard = getCoverHard({
  price: prices[INPUT_VALUE_COVER_TYPE_HARD],
  carousel: [
    'assets/images/covers/letsmakemetro/HC01.jpg',
    'assets/images/covers/letsmakemetro/HC02.jpg',
    'assets/images/covers/letsmakemetro/HC03.jpg',
  ],
});

const reviewMock: IReview = {
  photoImgSrc: 'https://placehold.co/349',
  userPhotoImgSrc: 'https://placehold.co/100',
  userName: '',
  text: [
    '息子のクリスマスプレゼントで購入🎄🎁',
    '息子が主人公で物語がはじまるとっても素敵な絵本💐',
    '絵も可愛くて息子も母もニコニコ︎︎︎︎︎😀出産祝いにもいいなって思った🕊',
  ],
};

const LetsMakeMetro: IBookPreview = {
  ...LetsMakeMetroShared,
  caption: '地下鉄をつくろう！',
  summary:
    'いつも使っている地下鉄はどうやってできたの？東洋で初めて地下鉄を作った早川徳次さんと一緒に、地下鉄を作ろう！',
  prices: [
    [INPUT_VALUE_COVER_TYPE_SOFT, prices[INPUT_VALUE_COVER_TYPE_SOFT]],
    [INPUT_VALUE_COVER_TYPE_HARD, prices[INPUT_VALUE_COVER_TYPE_HARD]],
  ],
  photos: [
    'assets/images/TM-BK2-carousel01.jpg',
    'assets/images/TM-BK2-carousel02.jpg',
    'assets/images/TM-BK2-carousel03.jpg',
    'assets/images/TM-BK2-carousel04.jpg',
    'assets/images/TM-BK2-carousel05.jpg',
  ],
  menuPhoto: 'assets/images/lmm-sample.jpg',
  previewPhoto: 'assets/images/lmm-sample.jpg',
  // TODO
  properties: {
    purpose: [PURPOSE_ADVENTURE, PURPOSE_BIRTH_GIFT],
    age: {
      start: 0,
      end: 3,
    },
  },
  notice: {
    caption: '地下鉄の父・早川徳次と地下鉄の子',
    description:
      'いつも使っている地下鉄はどうやってできたの？　日本で初めて地下鉄を作った早川徳次さんと一緒に日本初の地下鉄を作ろう！',
    points: [
      {
        imgSrc: 'assets/images/welcome-notice-point-1.png',
        caption: '5~10歳におすすめ',
      },
      {
        imgSrc: 'assets/images/welcome-notice-point-2.png',
        caption: '歴史や地下鉄を学ぶ',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタマイズができるの？',
      description:
        '・子どもの名前を入れる<br>・子どものイラストを選ぶ<br>・関心に合わせてストーリーが変化する<br>・メッセージを書き込む<br>・写真を入れる',
    },
    {
      caption: '絵本のストーリーは？',
      description:
        '今から100年以上前の東京では、ある男の人が地下鉄を作ろうとしていました。同じ志を持つ子供と一緒に地下鉄作りが始まります！　さぁ、どんな地下鉄になるかな？',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description:
        '全ての絵本は１冊ずつ、ご注文を受けてからオーダーメイドで印刷・製本されます。マットで高級感のある、環境に配慮した用紙を使用しています。<br><br><b>・全34 ページ<br>・縦21cm x 横29.7cm（本文部分）のA4ヨコサイズ<br>・日本国内で製造</b>',
    },
  ],
  inputs: [
    LetsMakeMetroInputsKidsName,
    LetsMakeMetroInputsKunChan,
    LetsMakeMetroInputsGender,
    LetsMakeMetroInputsCanvasGirl,
    LetsMakeMetroInputsCanvasBoy,
  ],
  banner: {
    imgSrc: 'assets/images/bk3-banner-desktop-JP.jpg',
    imgSrcLtMd: 'assets/images/bk3-banner-mobile-JP.jpg',
    text: 'まいにちが　だいぼうけん。　ここにある　まほうを　みつけよう。',
    textColor: EBannerTextColor.dark,
  },
  description: [
    {
      imgSrc: 'assets/images/TM-BK2-point01.jpg',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: /* html */ `<span style="font-family: ZenMaruGothic">歴史上の偉人と共に鉄道を作る！</span>`,
        },
        {
          type: EDescriptionTextItemType.regular,
          text: '鉄道好きなあの子が、早川徳次と共に鉄道を作る仲間に！　偉人と一緒に地下鉄の成り立ちが学べる。',
        },
      ],
    },
    {
      imgSrc: 'assets/images/TM-BK2-point02.jpg',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: /* html */ `<span style="font-family: ZenMaruGothic">関心のある分野の歴史を追体験</span>`,
        },
        {
          type: EDescriptionTextItemType.regular,

          text: `「地下鉄を作る」と言っても、必要な作業はたくさん……！　トンネルの採掘、電車の製造、駅の構築、運転士の育成などなど……。お子さまが興味のある分野の物語を追体験しましょう。`,
        },
      ],
    },
    {
      imgSrc: 'assets/images/TM-BK2-point03.jpg',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: /* html */ `<span style="font-family: ZenMaruGothic">子どもの背中を押すメッセージを</span>`,
        },
        {
          type: EDescriptionTextItemType.regular,

          text: `誰もが不可能だと思っていた日本に地下鉄を作ること……。けれども、たくさんの仲間を得て、夢は現実となりました。鉄道を実現させた早川さんの物語と共に、お子さまに応援のメッセージを残しましょう！`,
        },
      ],
    },
    {
      imgSrc: 'assets/images/TM-BK2-point04.gif',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: /* html */ `<span style="font-family: ZenMaruGothic">東京メトロの歴史を知ろう！</span>`,
        },
        {
          type: EDescriptionTextItemType.regular,

          text: `普段何気なく使っている地下鉄……。どんな人たちが、どんな思いで建設にかかわっていたのか、絵本を通して学びましょう！　読み終わると、普段通り過ぎていく駅やトンネルが少し特別に感じるはずです。`,
        },
      ],
    },
  ],
  review: {
    text: [
      '丁度地下鉄開業100周年ということで、電車好きな小学生の孫に買ってみました。地下鉄ができる過程を知れて孫も私（じじ）も勉強になり読み物として楽しめました。',
    ],
  },
  reviews: [
    reviewMock,
    reviewMock,
    reviewMock,
    reviewMock,
    reviewMock,
    reviewMock,
  ],
  options: {
    [INPUT_VALUE_COVER_TYPE_HARD]: coverHard,
    [INPUT_VALUE_COVER_TYPE_SOFT]: coverSoft,
  },
  option: INPUT_VALUE_COVER_TYPE_SOFT,
  popularity: 15,
  createdAt: new Date('2025-11-26'),
};

export default LetsMakeMetro;
